import { Button } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useCustomTranslation } from "../../hooks/useCustomTranslation";

const ImageInputV2 = ({
  defaultImage,
  image,
  onChange,
  removeImage,
  removeDefaultImage,
  helperText,
  placeholder,
}) => {
  const { t } = useCustomTranslation("Créer un Kiosk");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = ['image/png', 'image/jpeg'];
      const allowedExtensions = ['.png', '.jpg', '.jpeg'];
      const lastDotIndex = file.name.lastIndexOf('.');
      const fileExtension = lastDotIndex !== -1 ? file.name.toLowerCase().substring(lastDotIndex) : '';
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        alert('Only PNG and JPEG files are allowed.');
        e.target.value = ''; // Reset input to allow re-selection
        return;
      }
    }
    onChange(e);
  };
  return (
    <div className="w-full flex space-x-2">
      <div className="flex flex-1 flex-col">
        <div className="flex flex-1 flex-col justify-center items-center space-y-2">
          <div className="border outline-gray-500 outline-dashed rounded-md flex w-full justify-center items-center h-[200px] text-gray-500">
            {defaultImage && !image ? (
              <img
                className="object-contain h-full w-full"
                src={`${process.env.REACT_APP_S3_URL}${defaultImage}`}
              />
            ) : (
              <></>
            )}
            {image ? (
              <img
                alt={image.name}
                className="object-contain h-full w-full"
                src={URL.createObjectURL(image)}
              />
            ) : (
              <></>
            )}
            {!image && !defaultImage ? <div>{placeholder}</div> : <></>}
          </div>
          <div className="flex flex-1 space-x-4 w-full">
            <Button
              className="flex flex-1"
              size="small"
              variant="contained"
              onClick={() => document.getElementById("imageInput").click()}
            >
              <FileUploadOutlinedIcon /> {t("create_kiosk_uploadImage_text")}
              <input
                styles={{ display: "none" }}
                type="file"
                accept="image/png,image/jpeg"
                hidden
                onChange={handleFileChange}
                id="imageInput"
              />
            </Button>
            {!defaultImage ? (
              <Button
                className="flex flex-1"
                variant="contained"
                color="error"
                disabled={image ? false : true}
                onClick={removeImage}
              >
                {t("create_kiosk_removePreview_text")}
              </Button>
            ) : (
              <></>
            )}
            {!image && defaultImage ? (
              <Button
                className="flex flex-1"
                variant="contained"
                color="error"
                disabled={defaultImage ? false : true}
                onClick={removeDefaultImage}
              >
                {t("create_kiosk_removeOrigionalPreview_text")}
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>
        <label className="mt-2 text-sm text-gray-500">{helperText}</label>
      </div>
    </div>
  );
};

export default ImageInputV2;
